var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStudentEnroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2915_9855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 4.41707V3.8672C21.9983 2.34913 20.768 1.11888 19.2499 1.11707H2.74993C1.23186 1.11888 0.00181274 2.34913 0 3.8672V4.41707H22.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.51721V18.1671C0.00181274 19.6852 1.23186 20.9155 2.74993 20.9171H19.2499C20.768 20.9155 21.9983 19.6852 22.0001 18.1671V5.51721H0ZM3.3 9.36708C3.3 9.22125 3.35781 9.08127 3.46093 8.97814C3.56426 8.87502 3.70404 8.81701 3.85007 8.81721H8.25C8.39583 8.81701 8.53581 8.87502 8.63893 8.97814C8.74226 9.08127 8.80007 9.22125 8.80007 9.36708V12.6671C8.80007 12.8131 8.74226 12.9529 8.63893 13.0562C8.53581 13.1593 8.39583 13.2171 8.25 13.2171H3.85007C3.70404 13.2171 3.56426 13.1593 3.46093 13.0562C3.35781 12.9529 3.3 12.8131 3.3 12.6671V9.36708ZM18.15 16.5171H3.85007C3.54633 16.5171 3.3 16.2708 3.3 15.9671C3.3 15.6633 3.54633 15.4172 3.85007 15.4172H18.15C18.4537 15.4172 18.7001 15.6633 18.7001 15.9671C18.7001 16.2708 18.4537 16.5171 18.15 16.5171ZM18.15 13.2171H11.55C11.2463 13.2171 10.9999 12.9708 10.9999 12.6671C10.9999 12.3633 11.2463 12.1172 11.55 12.1172H18.15C18.4537 12.1172 18.7001 12.3633 18.7001 12.6671C18.7001 12.9708 18.4537 13.2171 18.15 13.2171ZM18.15 9.91714H11.55C11.2463 9.91714 10.9999 9.67081 10.9999 9.36708C10.9999 9.06334 11.2463 8.81721 11.55 8.81721H18.15C18.4537 8.81721 18.7001 9.06334 18.7001 9.36708C18.7001 9.67081 18.4537 9.91714 18.15 9.91714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40039 9.91724H7.70039V12.1173H4.40039V9.91724Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2915_9855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStudentEnroll);
export default __webpack_public_path__ + "static/media/ic-student-enroll.29832f23173220d523d6871d9d02c058.svg";
export { ForwardRef as ReactComponent };